export default function HowItWorks() {
  const steps = [
    {
      number: '1',
      icon: 'ri-file-list-3-line',
      title: 'Initial Screening Questionnaire',
      description: 'Complete a brief online screening questionnaire to help us understand your symptoms and history. Takes just 10-15 minutes from any device.',
      time: '10-15 minutes'
    },
    {
      number: '2',
      icon: 'ri-stethoscope-line',
      title: 'Remote Testing',
      description: 'A remote, online assessment administered by one of our trained technicians. Takes approximately 30–45 minutes to complete from the comfort of your own home.',
      time: '30-45 minutes'
    },
    {
      number: '3',
      icon: 'ri-file-text-line',
      title: 'Receive Results',
      description: 'Receive your detailed diagnostic report delivered securely to your portal. Your report can be shared with your PCP or mental health provider if you wish.',
      time: 'Within 48 hours'
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-violet-600 font-semibold text-sm uppercase tracking-wide">Simple Process</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-3 mb-4">
            Get Tested In Three Easy Steps
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Our streamlined process makes getting an ADHD testing simple, fast, and stress-free
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-1/3 left-0 right-0 h-0.5 bg-gradient-to-r from-violet-200 via-violet-400 to-violet-200" style={{ top: '80px' }}></div>
          
          <div className="grid md:grid-cols-3 gap-8 relative">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-white p-8 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 border border-stone-100">
                  <div className="flex flex-col items-center text-center">
                    <div className="w-20 h-20 flex items-center justify-center bg-violet-600 rounded-full mb-6 relative z-10">
                      <span className="text-3xl font-bold text-white">{step.number}</span>
                    </div>
                    
                    <div className="w-16 h-16 flex items-center justify-center bg-violet-50 rounded-2xl mb-5">
                      <i className={`${step.icon} text-3xl text-violet-600`}></i>
                    </div>
                    
                    <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                    <p className="text-sm text-gray-600 leading-relaxed mb-4">{step.description}</p>
                    <span className="text-xs text-violet-600 font-semibold italic">{step.time}</span>
                  </div>
                </div>
                
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-20 -right-4 text-violet-400 text-2xl">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 text-center bg-violet-50 rounded-2xl p-8">
          <h3 className="text-xl font-bold text-gray-900 mb-3">What Happens After Testing?</h3>
          <p className="text-sm text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Once your assessment is complete, you'll receive a comprehensive report that can be shared with your primary care physician or psychiatrist. We'll also provide resources for treatment options and lifestyle changes to help you thrive.
          </p>
        </div>
      </div>
    </section>
  );
}
